import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const ProgressContainer = styled("div")(() => ({
  height: "320px",
  maxWidth: "32px",
  width: "100%",

  "@media (min-width: 600px)": {
    alignItems: "center",
    height: "40px",
    maxWidth: "100%",
  },

  "&#mobileProgressionComponent": {
    display: "flex",

    "@media (min-width: 600px)": {
      display: "none",
    },
  },

  "&#desktopProgressionComponent": {
    display: "none",

    "@media (min-width: 600px)": {
      display: "flex",
    },
  },
}));

interface ProgressFillProps {
  percentage: number;
}

export const ProgressFill = styled("div")(({ percentage }: ProgressFillProps) => ({
  backgroundColor: "rgba(0, 85, 164, 1)",
  minHeight: `${percentage}%`,
  width: "4px",

  maxHeight: "276px",
  marginLeft: "1px",
  transform: "translateY(-1px)",
  zIndex: 4,
  position: "relative",

  "@media (min-width: 600px)": {
    minWidth: percentage === 100 ? "0%" : `${percentage}%`,
    width: percentage === 100 ? `${percentage}%` : "0%",
    maxWidth: "100%",
    height: "4px",
    left: 0,
    marginLeft: percentage === 0 ? "0px" : "3px",
    marginRight: percentage === 100 ? "20px" : "0",
  },
}));

export const ProgressDots = styled("div")(() => ({
  width: "1px",
  border: "none",
  borderLeft: "2px dashed rgba(152, 162, 179, 1)",
  color: "#fff",
  marginLeft: "2px",
  height: "100%",
  position: "relative",

  "@media (min-width: 600px)": {
    width: "100%",
    height: "1px",
    border: "none",
    borderTop: "2px dashed rgba(152, 162, 179, 1)",
    color: "#fff",
    marginRight: "20px",
  },
}));

export const LineContainer = styled("div")(({ percentage }: ProgressFillProps) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  position: "relative",

  maxHeight: percentage !== 100 ? "320px" : "300px",
  height: "100%",
  width: "100%",

  "@media (min-width: 600px)": {
    flexDirection: "row",
    maxHeight: "4px",
  },
}));

export const ArrowContainer = styled("div")(({ percentage }: ProgressFillProps) => ({
  position: "absolute",
  left: "7px",
  top: `${percentage}%`,
  height: "20px",
  backgroundColor: "#F1F6FB",
  zIndex: 5,
  transform: "rotate(90deg)",

  "@media (min-width: 600px)": {
    transform: "rotate(0deg)",
    left: `${percentage}%`,
    top: "-10px",
  },
}));

interface CircleProps {
  filled: boolean;
}

export const Circle = styled("span")(({ filled }: CircleProps) => ({
  height: "5px",
  borderRadius: "50%",
  border: "2px solid rgba(152, 162, 179, 1)",
  backgroundColor: filled ? "rgba(0, 85, 164, 1)" : "transparent",

  padding: "6px",
  zIndex: 5,
}));

export const useStyles = makeStyles(() => ({
  progressArrow: {
    tranform: "rotate(90deg)",
  },
  initialCircle: {
    marginBottom: "4px",
  },
  endCircle: {
    margin: "4px 0px 0px 1px",

    "@media (min-width: 600px)": {
      position: "absolute",
      right: 0,
      margin: "4px 0px 7px 1px",
    },
  },
}));
